import React from 'react';
import styles from './MenuItem.module.css';
import { NavLink, useLocation } from 'react-router-dom';

/**
 * Individual menu item component that renders as a navigation link
 * Includes accessibility attributes and active state styling
 */
const MenuItem = ({ label, path, icon, OnHide, disableNavigation = false }) => {
    const location = useLocation();
    const isActive = location.pathname === path;
    
    // Se a navegação estiver desabilitada, renderiza um div em vez de um NavLink
    if (disableNavigation) {
        return (
            <div
                style={{ textDecoration: 'none', cursor: 'not-allowed', pointerEvents: 'none' }}
                className={`${styles.disabledLink}`}
                aria-disabled="true"
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    return false;
                }}
            >
                <div className={`${styles.container} ${styles.disabled}`}>
                    <span className={`${styles.icon} ${styles.disabledIcon}`}>{icon}</span>
                    <span className={`${styles.label} ${styles.disabledLabel}`}>{label}</span>
                </div>
            </div>
        );
    }

    return (
        <NavLink
            to={path}
            style={{ textDecoration: 'none' }}
            onClick={OnHide}
            className={({ isActive }) => isActive ? styles.activeLink : ''}
            aria-current={isActive ? 'page' : undefined}
        >
            <div className={`${styles.container} ${isActive ? styles.active : ''}`}>
                <span className={styles.icon}>{icon}</span>
                <span className={styles.label}>{label}</span>
            </div>
        </NavLink>
    );
};

export default MenuItem;